import {
  mapGetCompanyArtistsResponseType,
  useFindCompanyArtistsSuspense,
} from '@api';
import {
  ArtistAnchor,
  TouringCard,
  TouringCardHeader,
  TouringCardSection,
  TouringCardTitle,
} from '@common';
import { Grid, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { Route } from 'src/routes/_rootLayout/companies/$id.artists';
import { CompanyArtistsTable } from './components';

export const CompanyArtists: React.FC = () => {
  const { t } = useTranslation('companyDetailsArtists');
  const { id: companyId } = Route.useParams();

  const { data } = useFindCompanyArtistsSuspense(companyId, {
    query: {
      select: (response) => mapGetCompanyArtistsResponseType(response),
    },
  });

  if (data.artists.length === 0) {
    return (
      <Text c="dimmed" py="md">
        {t('COMPANY_ARTISTS.EMPTY_STATE.MESSAGE')}
      </Text>
    );
  }

  return (
    <Grid columns={12} gap="md" data-testid="company-artists">
      {data.artists.map((item) => (
        <Grid.Col key={item.artist.id} span={{ base: 12, sm: 6, md: 4 }}>
          <TouringCard data-testid={`company-artists-card-${item.artist.id}`}>
            <TouringCardHeader>
              <TouringCardTitle>
                <ArtistAnchor artist={item.artist} />
              </TouringCardTitle>
            </TouringCardHeader>
            <TouringCardSection>
              <CompanyArtistsTable contacts={item.contacts} />
            </TouringCardSection>
          </TouringCard>
        </Grid.Col>
      ))}
    </Grid>
  );
};
